import script from "./DownloadFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadFiles.vue?vue&type=script&setup=true&lang=js"

import "./DownloadFiles.vue?vue&type=style&index=0&id=18ddfbff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18ddfbff"]])

export default __exports__